import { BpArticle } from '../../components/cards/article/BpArticle'
import React from 'react'

interface AdCellProps {
  title: string
  text: string
  finish_domain: string
}

export const AdCell = ({ title, text, finish_domain }: AdCellProps) => {
  return <BpArticle link={finish_domain} text={text} title={title} />
}
